import { rest } from '@lib/api';
import { getSiteURL } from '@lib/utils';
import NotFoundPage from './404';

// ---------------------------------------------------------

const abs = (pathname) => {
  return pathname.slice(0, 4) !== 'http' ? `${getSiteURL()}${pathname}` : pathname;
};

// ---------------------------------------------------------

export default function UnknownRouteHandler() {
  <NotFoundPage />;
}

export const getServerSideProps = async ({ req }) => {
  const { url } = req;

  url.replace('listrdr', 'listing');
  const payload = await rest(`/redirected-urls/${url}`, {}, true);

  // Note, payload still gets returned if the API returns a 404 or 500 error
  if (payload) {
    const {
      data: { targetUrl, httpResponseCode: statusCode }
    } = payload;

    // Only redirect if a redirect URL has been successfully retrieved (301 || 302)
    if (targetUrl && (statusCode === 301 || statusCode === 302)) {
      return {
        props: {},
        redirect: {
          destination: abs(targetUrl),
          statusCode
        }
      };

      // Otherwise forward the user to a 404 page
    } else {
      return {
        notFound: true
      };
    }
  }

  // Fallback to a 404 if somehow the above fails
  return {
    notFound: true
  };
};
